import { useGetPrice } from "modules/Payment/common/hooks"
import { usePaymentContext } from "modules/Payment/PaymentContext"
import { BookingStatusMap } from "utils/interfaces"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"

export function usePrice() {
    const [{ selectedDiscount, bookingDetails, bookingStatus }] = usePaymentContext()

    const [price, discountPrice] = useGetPrice()
    const [{ isVerified }] = useClientContext()

    const discountId = selectedDiscount ?? bookingDetails.discounted

    const defaultPrice = (function () {
        if (isVerified && discountId === undefined) {
            return price
        }
        if (discountId !== undefined || discountPrice === 0) {
            return discountPrice
        }
        if (bookingStatus === BookingStatusMap.PAY_STARTED && price !== discountPrice) {
            return discountPrice
        }
    })()

    const showDiscount = defaultPrice !== price

    return {
        price: defaultPrice,
        discount: price,
        showDiscount,
    }
}
